import { Injectable } from '@angular/core';
import { BookingSummary, ConfirmPayment, DriverBookingListRequest, DriverBookingResponse } from '@core/models/booking.model';
import { Utility } from '@shared/services/utility.abstract';
import { APIService } from '@core/services/api.service';
import { CouponResponse } from '@core/models/promo-code.modal';
import { AvailableOfferResponse, ParkingLot, UserCredit, } from '@core/models/api.response.modal';
import { BehaviorSubject, Observable } from 'rxjs';
import { ParkingLotDetail } from '@core/models/parking-detail.model';

@Injectable({
  providedIn: 'root'
})
export class DriverService {
  private readonly dataSource = new BehaviorSubject<any[]>([]);
  currentData = this.dataSource.asObservable();
  constructor(private readonly apiService: APIService) { }

  createUser(data) {
    return this.apiService.postWithAllResponse('User/CreateUser', data)
  }
  createGroupUser(data) {
    return this.apiService.postWithAllResponse('User/CreateGroupUser', data)
  }
  sendOtpForVerification(data) {
    return this.apiService.postWithAllResponse('User/SendOtpForVerification', data)
  }
  verifyEmailByOTP(otp) {
    return this.apiService.postWithAllResponse('User/VerifyEmailByOTP', otp)
  }

  getBookingList(data: DriverBookingListRequest) {
    return this.apiService.postWithAllResponse<DriverBookingResponse>('BookingSlot/GetBookingListByDriverId ', data);
  }

fetchBookingSummary(bookingId: string) {
  const timeZone = Utility.getLocalTimeZone();
  return this.apiService.get<BookingSummary>(`BookingSlot/getBookingDetailById?id=${bookingId}&timeZone=${timeZone}`);
}

cancelRecurringBookingById(bookingIdObj) {
  return this.apiService.postWithAllResponse('BookingSlot/CancelRecurringBookingById',bookingIdObj);
}

cancelRecurringBookingByIdExceptDriver(bookingIdObj) {
  return this.apiService.postWithAllResponse('BookingSlot/CancelRecurringBookingBySuperAdmin',bookingIdObj);
}

deleteBookingID(bookingId: string) {
  return this.apiService.delete(`BookingSlot/DeleteBooking?bookingId=${bookingId}`);
}

CheckCouponValidityWithBookingId(couponCode:string, bookingId: string){
  return this.apiService.get<CouponResponse>(`User/CheckCouponValidity?couponCode=${couponCode}&bookingId=${bookingId}`)
}

getBookingCount(req){
  return this.apiService.post('BookingSlot/GetBookingCount',req)
}

addPaymentMethod(){
  return this.apiService.postWithAllResponse('Stripe/AddPaymentMethod');
}

setDefualtPaymentMethod(request){
  return this.apiService.postWithAllResponse('Stripe/SetDefualtPaymentMethod',request);
}

deletePaymentMethod(request){
  return this.apiService.deleteWithBodyRequest('Stripe/DeletePaymentMethod',request);
}

RePaymentSession(request){
  return this.apiService.postWithAllResponse('User/CreateRePaymentSession',request);
}

paymentUrlMethod(request){
  return this.apiService.postWithAllResponse('Stripe/GetPaymentUrlByBookingIdOrInvoiceId',request);
}

getInvoiceListBookings(request) {
  return this.apiService.postWithAllResponse('BookingSlot/GetInvoiceListBookings', request);
}

createPaymentSession(data) {
  return this.apiService.post('User/CreatePaymentSession',data);
}

confirmPayment(confirmPaymentData:ConfirmPayment){
  return this.apiService.post<ConfirmPayment>('User/StripePayment',confirmPaymentData)
}

  CheckCouponValidity(couponCode:string){
    return this.apiService.get<CouponResponse>(`User/CheckCouponValidity?couponCode=${couponCode}`)
  }

  getOfferList(data){
    return this.apiService.post<AvailableOfferResponse>('ParkingLot/GetOffersByBookingId',data)
  }

  UpdateBookingByOffer(data){
    return this.apiService.post('BookingSlot/UpdateOfferAndCredit',data)
  }
  getOfferDetails(id:any) {
    return this.apiService.getWithAllResponse<any>(`User/GetOfferListByUserId?status=${id}`);
   }

   getTransactionsOfDriver(req : any) {
    return this.apiService.postWithAllResponse('BookingSlot/GetTransactionsOfDriver' , req)
  }
  getUserCredit() {
    return this.apiService.get<UserCredit>(`BookingSlot/GetUserCredit`)
  }

  getAllBookmarkParkingLotsList(){
    return this.apiService.getWithAllResponse<ParkingLot[]>('ParkingLot/getAllBookmarkParkingLotsList')
  }

  deleteBookmarkByParkingLotId(parkingLotId){
    return this.apiService.delete(`ParkingLot/deleteBookmarkByParkingLotId?parkingLotId=${parkingLotId}`);
  }

  changeData(data: any[]) {
    this.dataSource.next(data);
  }

  clearData(){
    this.dataSource.next([]);
  }
  getParkingLotInvoiceForDriver(req){
    return this.apiService.postWithAllResponse('ParkingLot/GetParkingLotInvoiceForDriver', req)
  }
  getparkingDetailById(id: string): Observable<ParkingLotDetail> {
    return this.apiService.get<ParkingLotDetail>(`ParkingLot/GetParkingLotsById?id=${id}&isWeb=true` );
  }
  createParkingLotInvoiceForDriver(req){
    return this.apiService.postWithAllResponse('ParkingLot/CreateParkingLotInvoiceForDriver' , req)
  }
  shareInvoice(req){
    return this.apiService.postWithAllResponse('ParkingLot/ShareParkingInvoiceToDriver' , req)
  }
  downloadInvoice(req){
    return this.apiService.postWithAllResponse('ParkingLot/DownloadParkingLotInvoiceOfDriver' , req)
  }

  getAllPatmentMethodsList(){
    return this.apiService.getWithAllResponse('Stripe/GetAllPaymentMethodsList');
  }

  CancelAssistedPendingBookingById(request) {
    return this.apiService.postWithAllResponse('BookingSlot/CancelAssistedPendingBookingById', request)
  }

  getInvoiceListBookingsDriver(request) {
    return this.apiService.postWithAllResponse('BookingSlot/GetInvoiceListBookingsDriver', request);
  }

  CancelMyInvoiceByIdOrBookingId(request) {
    return this.apiService.postWithAllResponse('BookingSlot/CancelMyInvoiceByIdOrBookingId', request)
  }
}
